/* eslint-disable no-case-declarations */
import store from '../../store'
import { CURB_LANE_WIDTH, CURB_LANE_WIDTH_VALUES } from '../constants/freight'
import { setFreightInputs } from '../slices/criteriaSelection/freight'

export function setFreightSegmentInput() {
  const { freight, street, modalTiers } = store.getState()
  const { Freight: FTier } = modalTiers

  const { segments } = street

  // If Freight Tier is 0 or NA , do not change inputs
  if (FTier === 0) {
    return
  }

  for (const key of Object.keys(freight)) {
    switch (key) {
      case CURB_LANE_WIDTH:
        // Check if there are any truck lanes
        const firstLaneIndex = segments.findIndex(
          (segment) => segment?.type === 'drive-lane'
        )
        // Reverse segments to find last lane id
        const copyOfSegmentsToReverse = [...segments]

        const lastLaneId = copyOfSegmentsToReverse
          .reverse()
          .find((segment) => segment?.type.indexOf('drive-lane') !== -1)?.id

        const lastLandeIndex = segments.findIndex(
          (segment) => segment?.id === lastLaneId
        )
        const curbLaneArr = segments.filter(
          (segment, index) =>
            (segment?.type === 'drive-lane' && index === firstLaneIndex) ||
            (segment?.type === 'drive-lane' && index === lastLandeIndex)
        )

        if (curbLaneArr.some((lane) => lane?.width > 11 && lane?.width <= 12)) {
          store.dispatch(
            setFreightInputs({ field: key, value: CURB_LANE_WIDTH_VALUES[2] })
          )
        } else if (curbLaneArr.some((lane) => lane?.width > 12)) {
          store.dispatch(
            setFreightInputs({ field: key, value: CURB_LANE_WIDTH_VALUES[3] })
          )
        } else if (curbLaneArr.some((lane) => lane?.width === 11)) {
          store.dispatch(
            setFreightInputs({ field: key, value: CURB_LANE_WIDTH_VALUES[1] })
          )
        } else if (curbLaneArr.some((lane) => lane?.width < 11)) {
          store.dispatch(
            setFreightInputs({ field: key, value: CURB_LANE_WIDTH_VALUES[0] })
          )
        } else {
          store.dispatch(setFreightInputs({ field: key, value: '' }))
        }
    }
  }
}
